import React, { useState } from "react";
import useStyles from "../styles";
import config from "../../../config";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import InputComponent from "../../partner/components/inputComponent";
import InputDecimal from "../../partner/components/inputDecimal";
import { CircularProgress } from "@material-ui/core";
import Modal from "../../modals/Modal";
import SwitchHasCost from "../../user/components/switch";

export default function AddService() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{1,500}$/, // Letras
        textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
    }

    const classes = useStyles();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [serviceName, setServiceName] = useState({ text: '', valid: null });
    const [serviceCost, setServiceCost] = useState({ text: '', valid: null });
    const [hasCost, setHasCost] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);

        if (serviceName.valid === 'true') {
            const newService = {
                serviceName: serviceName.text, serviceCost: hasCost == false ? '0.00' : serviceCost.text == '' ? '0.00' : serviceCost.text,
                hasCost: hasCost == true ? 1 : 0
            };

            const response = await fetch(baseUrl + "createService", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newService)
            });
            const json = await response.json();
            if (json.message == "Ok") {
                setServiceName({ text: '', valid: null });
                setServiceCost({ text: '', valid: null });
                setHasCost(false);
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}
            <PageTitle title="Configuración" />

            <div className={classes.divAddPage} >
                <div className={classes.divTitle}>
                    <label className={classes.titleStyle}>Agregar servicio</label>
                </div>

                <div className={classes.divColumn} >
                    <InputComponent
                        text={serviceName}
                        setPartnerCode={setServiceName}
                        type="text"
                        label="Nombre"
                        name="name"
                        regularExpression={expressions.textNumberAndSymbols}
                        placeholder="Nombre"
                    />

                    <SwitchHasCost
                        value={hasCost}
                        setValue={setHasCost}
                        label="¿Tiene costo?"
                    />

                    {hasCost ? (
                        <InputDecimal
                            text={serviceCost}
                            setPartnerCode={setServiceCost}
                            type="text"
                            label="Costo"
                            name="price"
                            placeholder="100.00"
                        />
                    ) : (
                        <></>
                    )}

                </div>

                <div className={classes.divButton}>
                    {isLoading ? (
                        <div className={classes.loginLoader} >
                            <CircularProgress size={26} />
                        </div>

                    ) : (
                        <button
                            className={serviceName.valid === 'true' ?
                                classes.enableButton : classes.disableButton}
                            onClick={onSubmit}
                        >Agregar</button>
                    )}
                </div>
            </div>
        </div>
    );
}
